import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

var _ = require('lodash');
import AsyncCreatableSelect from 'react-select/async-creatable';
const axios = require('axios').default;
import Popup from "reactjs-popup";
import { mergeSelectStyles } from '../../../shared/darkSelectStyles';
import popupContentStyle from '../../../shared/popupContentStyle';
import InputMask from "react-input-mask";
import { toast } from 'react-toastify';
import contactTypeOptions from '../../shared/constants/contactTypeOptions';

const selectStyles = mergeSelectStyles({
  container: (base, state) => ({
    ...base,
    opacity: state.isDisabled ? ".5" : "1",
    backgroundColor: "transparent",
    zIndex: "999"
  }),
  control: (base, state) => ({
    ...base,
    minHeight: "31px",
    fontSize: "14px",
    borderRadius: "0px",
    borderWidth: "1px",
    borderColor: "var(--od-c-d5d7da, #ced4da)",
    padding: "1px 0px",
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : "none",
    boxSizing: "border-box",
    "&:hover": {
      borderColor: "var(--od-c-d5d7da, #ced4da)"
    }
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "4px 8px",
    display: "flex",
    alignItems: "center"
  }),
  input: (base) => ({
    ...base,
    margin: "0px",
    paddingTop: "0px",
    paddingBottom: "0px"
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  indicatorsContainer: (base) => ({
    ...base
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px"
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "4px"
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: provided => ({ ...provided, zIndex: "9999 !important" })
});

const inlineMenuContentStyle = {...popupContentStyle("215px"), textAlign: "left"};

const formatPhoneNumber = (phone) => {
  if (!phone) return '';

  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  return phone;
};

const canAddOfferContact = (offerContacts, offerContactToEdit) => {
  return !offerContacts.some((offerContact) => {
    return offerContact.id === undefined;
  });
}

const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

const canSubmitOfferContactForm = (offerContact) => {
  var noPhoneOrValidPhone = (
    offerContact
      && offerContact.contact
      && (
        !offerContact.contact.phone
          || offerContact.contact.phone.length === 0
          || offerContact.contact.phone.replace(/[^0-9]/g, '').length === 10
      )
  )

  var noEmailOrValidEmail = (
    offerContact
      && offerContact.contact
      && (
        !offerContact.contact.email
          || offerContact.contact.email.length === 0
          || validateEmail(offerContact.contact.email)
      )
  )

  return (
    offerContact
      && offerContact.contact
      && offerContact.contact.name
      && offerContact.contact.name.length > 0
      && noPhoneOrValidPhone
      && noEmailOrValidEmail
  );
}

const formatOptionLabel = ({ value, label, title_email_preview }) => {
  return (
    <div>
      <div style={{"fontSize": "12px"}}>{label}</div>
      {title_email_preview && title_email_preview.length > 0 ? (
        <div className="text-muted" style={{"fontSize": "10px"}}>
          {title_email_preview}
        </div>
      ) : null}
    </div>
  );
};

const debouncedFetch = _.debounce((inputValue, callback, team, offerContacts) => {
  var omitContactIds = offerContacts.filter((offerContact) => {
      return offerContact.id && offerContact.contact;
    })
    .map((offerContact) => {
      return offerContact.contact.id;
    });

  var contactPromise = axios.get('/teams/' + team.id + '/contacts/autocomplete', {
      params: {
        name: inputValue,
        omit_ids: omitContactIds
      }
    })
    .then(function (response) {
      return response.data.map(function(data){
        return Object.assign({}, data, {value: data.id, label: data.name, type: "Contact"});
      });
    })

  var agentPromise = axios.get('/agents/autocomplete', {
      params: {
        name: inputValue,
        team_id: team.id
      }
    })
    .then(function (response) {
      return response.data.map(function(data){
        return Object.assign({}, data, {value: data.id, label: data.name, type: "Agent"});
      });
    })

  Promise.all([contactPromise, agentPromise]).then((values) => {
    var combined = values.flat().sort(function (a, b) {
      return a.name.localeCompare(b.name);
    }).slice(0, 20);

    callback(combined);
  });
}, 250);

const OfferManageContacts = ({
  csrfToken,
  team,
  offer,
  currentUser,
  offerContacts,
  offerContactsChanged
}) => {
  const [offerContactToEdit, setOfferContactToEdit] = useState(null);

  const createOfferContactFromContactId = async (contactId, offerContact) => {
    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
      
      const response = await axios.post(`/teams/${team.id}/offer_contacts`, {
        offer_contact: {
          offer_id: offer.id,
          contact_id: contactId
        }
      });

      const newOfferContacts = offerContacts.map(oc =>
        oc === offerContact ? response.data : oc
      );
      offerContactsChanged(newOfferContacts);

      setOfferContactToEdit(null);
    } catch (error) {
      toast.error('Failed to add contact');
    }
  };

  const createOfferContactFromAgentId = async (agentId, offerContact) => {
    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

      const response = await axios.post(`/teams/${team.id}/offer_contacts`, {
        offer_contact: {
          offer_id: offer.id,
          contact_attributes: {
            agent_id: agentId,
            team_id: team.id
          }
        }
      });

      const newOfferContacts = offerContacts.map(oc =>
        oc === offerContact ? response.data : oc
      );
      offerContactsChanged(newOfferContacts);

      setOfferContactToEdit(null);
    } catch (error) {
      toast.error('Failed to add agent contact');
    }
  };

  const deleteOfferContact = async (offerContact) => {
    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
      await axios.delete(`/teams/${team.id}/offer_contacts/${offerContact.id}`);

      offerContactsChanged(offerContacts.filter(oc => oc.id !== offerContact.id));
    } catch (error) {
      toast.error('Failed to remove contact');
    }
  };

  const addOfferContact = () => {
    setOfferContactToEdit(null);
    const cleanedContacts = offerContacts.filter(oc => oc.id !== undefined);
    
    const newContact = { 
      id: undefined,
      contact: {
        name: '',
        email: '',
        phone: '',
        contact_type: '',
        title: '',
        company_name: ''
      }
    };
    
    const updatedContacts = [...cleanedContacts, newContact];
    offerContactsChanged(updatedContacts);
    setOfferContactToEdit(newContact);
  };

  const removeUnsavedOfferContact = () => {
    offerContactsChanged(offerContacts.filter(oc => oc.id !== undefined));
    setOfferContactToEdit(null);
  };

  const editOfferContact = (offerContact) => {
    const cleanedContacts = offerContacts.filter(oc => oc.id !== undefined);
    offerContactsChanged(cleanedContacts);
    
    const contactToEdit = {
      ...offerContact,
      contact: { ...offerContact.contact }
    };
    
    setOfferContactToEdit(contactToEdit);
  };

  const cancelEditOfferContact = () => {
    setOfferContactToEdit(null);
  };

  const saveOfferContactEdit = async () => {
    if (offerContactToEdit) {
      await updateOfferContact(offerContactToEdit);
      setOfferContactToEdit(null);
    }
  };

  const createOfferContact = async (offerContact) => {
    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

      const response = await axios.post(`/teams/${team.id}/offer_contacts`, {
        offer_contact: {
          offer_id: offer.id,
          contact_attributes: {
            name: offerContact.contact.name,
            email: offerContact.contact.email,
            phone: offerContact.contact.phone,
            contact_type: offerContact.contact.contact_type,
            title: offerContact.contact.title,
            company_name: offerContact.contact.company_name,
            team_id: team.id
          }
        }
      });

      const cleanedContacts = offerContacts.filter(oc => oc.id !== undefined);
      const newOfferContacts = [...cleanedContacts, response.data];
      offerContactsChanged(newOfferContacts);

      setOfferContactToEdit(response.data);
    } catch (error) {
      toast.error('Failed to create contact');
    }
  };

  const updateOfferContact = async (offerContact) => {
    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

      const response = await axios.patch(`/teams/${team.id}/offer_contacts/${offerContact.id}`, {
        offer_contact: {
          offer_id: offer.id,
          contact_attributes: {
            id: offerContact.contact.id,
            name: offerContact.contact.name,
            email: offerContact.contact.email,
            phone: offerContact.contact.phone,
            contact_type: offerContact.contact.contact_type,
            title: offerContact.contact.title,
            company_name: offerContact.contact.company_name,
            team_id: team.id
          }
        }
      });

      const newOfferContacts = offerContacts.map(oc => 
        oc.id === offerContact.id ? response.data : oc
      );
      offerContactsChanged(newOfferContacts);
    } catch (error) {
      toast.error('Failed to update contact');
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    
    if (offerContactToEdit) {
      if (offerContactToEdit.id) {
        saveOfferContactEdit();
      } else {
        createOfferContact(offerContactToEdit);
      }
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <form onSubmit={handleFormSubmit}>
          <div className="table-responsive">
            <table className="table no-top-border" style={{"borderCollapse": "separate", "borderSpacing": "0 1px"}}>
            <colgroup>
              <col span="1" width="20%" />
              <col span="1" width="20%" />
              <col span="1" width="11%" />
              <col span="1" width="11%" />
              <col span="1" width="11%" />
              <col span="1" width="20%" />
              <col span="1" width="7%" />
            </colgroup>
            <thead style={{"fontSize": "14px", "fontWeight": "normal"}}>
              <tr>
                <td className='border-0' style={{"padding": "12px 0px"}}>Name</td>
                <td className='border-0' style={{"padding": "12px 0px"}}>Email</td>
                <td className='border-0' style={{"padding": "12px 0px"}}>Phone</td>
                <td className='border-0' style={{"padding": "12px 0px"}}>Contact Type</td>
                <td className='border-0' style={{"padding": "12px 0px"}}>Title</td>
                <td className='border-0' style={{"padding": "12px 0px"}}>Company</td>
                <td className='border-0' style={{"padding": "12px 0px", "width": "50px"}}></td>
              </tr>
            </thead>
            <tbody style={{"fontSize": "16px"}}>
              {(() => {
                const persistedContacts = offerContacts.filter(oc => oc.id !== undefined);
                const newContacts = offerContacts.filter(oc => oc.id === undefined);

                persistedContacts.sort((a, b) => {
                  const nameA = (a.contact?.name || '').toLowerCase();
                  const nameB = (b.contact?.name || '').toLowerCase();
                  return nameA.localeCompare(nameB);
                });

                const sortedContacts = [...persistedContacts, ...newContacts];

                return sortedContacts;
              })().map((offerContact, index) => {
                const isEditing = offerContactToEdit && (
                  (!offerContactToEdit.id && offerContact === offerContactToEdit) ||
                  (offerContactToEdit.id && offerContact.id === offerContactToEdit.id)
                );

                if (isEditing && !offerContact.id) {
                  return (
                    <tr key={index} style={{"borderTop": "none"}}>
                      <td style={{"padding": "0px"}}>
                        <AsyncCreatableSelect
                          cacheOptions
                          autoFocus
                          styles={selectStyles}
                          placeholder="Enter name..."
                          menuPortalTarget={document.querySelector('body')}
                          defaultOptions
                          formatOptionLabel={formatOptionLabel}
                          formatCreateLabel={(label) => `Create "${label}"`}
                          onCreateOption={async (label) => {
                            const updatedContact = {
                              ...offerContactToEdit,
                              contact: { ...offerContactToEdit.contact, name: label }
                            };
                            setOfferContactToEdit(updatedContact);
                            
                            // Update array for new contacts
                            offerContactsChanged(offerContacts.map(oc => 
                              oc === offerContactToEdit ? updatedContact : oc
                            ));

                            // Submit the form and wait for the response
                            await createOfferContact(updatedContact);
                          }}
                          onChange={(option) => {
                            if(option.type === "Contact"){
                              createOfferContactFromContactId(option.id, offerContact);
                            } else if (option.type === "Agent") {
                              createOfferContactFromAgentId(option.id, offerContact);
                            }
                          }}
                          onInputChange={(inputValue, { action }) => {
                            if (action === 'input-change') {
                              const updatedContact = {
                                ...offerContactToEdit,
                                contact: { ...offerContactToEdit.contact, name: inputValue }
                              };
                              setOfferContactToEdit(updatedContact);
                              
                              // Also update the array for new contacts
                              offerContactsChanged(offerContacts.map(oc => 
                                oc === offerContactToEdit ? updatedContact : oc
                              ));
                            }
                          }}
                          loadOptions={(inputValue, callback) => debouncedFetch(inputValue, callback, team, offerContacts)} />
                      </td>
                      <td style={{"padding": "0px"}}>
                        <input type="email"
                              value={offerContactToEdit.contact.email || ""}
                              disabled={true}
                              className="form-control form-control-sm rounded-0"
                              style={{"borderWidth": "1px"}}
                              placeholder="Email" />
                      </td>
                      <td style={{"padding": "0px"}}>
                        <InputMask mask="(999) 999-9999"
                                  value={offerContactToEdit.contact.phone || ""}
                                  disabled={true}
                                  className="form-control form-control-sm rounded-0"
                                  style={{"borderWidth": "1px"}}
                                  placeholder="Phone"
                                  alwaysShowMask={false} />
                      </td>
                      <td style={{"padding": "0px"}}>
                        <select className="form-control form-control-sm rounded-0"
                                style={{"borderWidth": "1px"}}
                                value={offerContactToEdit.contact.contact_type || ""}
                                disabled={true}>
                          <option value="">Contact Type</option>
                          {contactTypeOptions.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </select>
                      </td>
                      <td style={{"padding": "0px"}}>
                        <input type="text"
                              value={offerContactToEdit.contact.title || ""}
                              disabled={true}
                              className="form-control form-control-sm rounded-0"
                              style={{"borderWidth": "1px"}}
                              placeholder="Title" />
                      </td>
                      <td style={{"padding": "0px"}}>
                        <input type="text"
                              value={offerContactToEdit.contact.company_name || ""}
                              disabled={true}
                              className="form-control form-control-sm rounded-0"
                              style={{"borderWidth": "1px"}}
                              placeholder="Company" />
                      </td>
                      <td style={{"padding": "0px"}}>
                        {currentUser.can_manage_offer_contacts ? (
                          <div className="d-flex align-items-center justify-content-end" style={{"marginTop": "1px"}}>
                            <button type="submit"
                                    disabled={!canSubmitOfferContactForm(offerContactToEdit)}
                                    className="btn btn-sm btn-primary rounded-circle"
                                    style={{"width": "28px", "height": "28px", "fontSize": "10px", "marginRight": "1px"}}
                                    title="Save">
                              <i className="fas fa-check"></i>
                            </button>
                            <button type="button"
                                    onClick={() => removeUnsavedOfferContact()}
                                    className="btn btn-sm btn-secondary rounded-circle"
                                    style={{"width": "28px", "height": "28px", "fontSize": "10px"}}
                                    title="Cancel">
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                        ) : null}
                      </td>
                    </tr>
                  );
                } else if (isEditing && offerContact.id) {
                  return (
                    <tr key={index} style={{"borderTop": "none"}}>
                      <td style={{"padding": "0px"}}>
                        <input type="text"
                              value={offerContactToEdit.contact.name || ""}
                              onChange={(e) => setOfferContactToEdit({
                                ...offerContactToEdit,
                                contact: { ...offerContactToEdit.contact, name: e.target.value }
                              })}
                              autoFocus
                              className="form-control form-control-sm rounded-0"
                              style={{"borderWidth": "1px"}}
                              placeholder="Name" />
                      </td>
                      <td style={{"padding": "0px"}}>
                        <input type="email"
                              value={offerContactToEdit.contact.email || ""}
                              onChange={(e) => setOfferContactToEdit({
                                ...offerContactToEdit,
                                contact: { ...offerContactToEdit.contact, email: e.target.value }
                              })}
                              className="form-control form-control-sm rounded-0"
                              style={{"borderWidth": "1px"}}
                              placeholder="Email" />
                      </td>
                      <td style={{"padding": "0px"}}>
                        <InputMask mask="(999) 999-9999"
                                  value={offerContactToEdit.contact.phone || ""}
                                  onChange={(e) => setOfferContactToEdit({
                                    ...offerContactToEdit,
                                    contact: { ...offerContactToEdit.contact, phone: e.target.value }
                                  })}
                                  className="form-control form-control-sm rounded-0"
                                  style={{"borderWidth": "1px"}}
                                  placeholder="Phone"
                                  alwaysShowMask={false} />
                      </td>
                      <td style={{"padding": "0px"}}>
                        <select className="form-control form-control-sm rounded-0"
                                style={{"borderWidth": "1px"}}
                                value={offerContactToEdit.contact.contact_type || ""}
                                onChange={(e) => setOfferContactToEdit({
                                  ...offerContactToEdit,
                                  contact: { ...offerContactToEdit.contact, contact_type: e.target.value }
                                })}>
                          <option value="">Contact Type</option>
                          {contactTypeOptions.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </select>
                      </td>
                      <td style={{"padding": "0px"}}>
                        <input type="text"
                              value={offerContactToEdit.contact.title || ""}
                              onChange={(e) => setOfferContactToEdit({
                                ...offerContactToEdit,
                                contact: { ...offerContactToEdit.contact, title: e.target.value }
                              })}
                              className="form-control form-control-sm rounded-0"
                              style={{"borderWidth": "1px"}}
                              placeholder="Title" />
                      </td>
                      <td style={{"padding": "0px"}}>
                        <input type="text"
                              value={offerContactToEdit.contact.company_name || ""}
                              onChange={(e) => setOfferContactToEdit({
                                ...offerContactToEdit,
                                contact: { ...offerContactToEdit.contact, company_name: e.target.value }
                              })}
                              className="form-control form-control-sm rounded-0"
                              style={{"borderWidth": "1px"}}
                              placeholder="Company" />
                      </td>
                      <td style={{"padding": "0px"}}>
                        <div className="d-flex align-items-center justify-content-end" style={{"marginTop": "1px"}}>
                          <button type="submit"
                                  disabled={!canSubmitOfferContactForm(offerContactToEdit)}
                                  className="btn btn-sm btn-primary rounded-circle"
                                  style={{"width": "28px", "height": "28px", "fontSize": "10px", "marginRight": "1px"}}
                                  title="Save">
                            <i className="fas fa-check"></i>
                          </button>
                          <button type="button"
                                  onClick={cancelEditOfferContact}
                                  className="btn btn-sm btn-secondary rounded-circle"
                                  style={{"width": "28px", "height": "28px", "fontSize": "10px"}}
                                  title="Cancel">
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                } else {
                  const contact = offerContact.contact;

                  return (
                    <tr key={index} style={{"borderTop": "none", "fontSize": "12px", "backgroundColor": "var(--od-c-fafafa, #f8f9fa)"}}>
                      <td className="overflow-ellipsis" style={{"padding": "3px 8px", "verticalAlign": "middle"}}>
                        {contact.name}
                      </td>
                      <td className="overflow-ellipsis" style={{"padding": "3px 8px", "verticalAlign": "middle"}}>
                        {contact.email || '--'}
                      </td>
                      <td className="overflow-ellipsis" style={{"padding": "3px 8px", "verticalAlign": "middle"}}>
                        {formatPhoneNumber(contact.phone) || '--'}
                      </td>
                      <td className="overflow-ellipsis" style={{"padding": "3px 8px", "verticalAlign": "middle"}}>
                        {contact.contact_type || '--'}
                      </td>
                      <td className="overflow-ellipsis" style={{"padding": "3px 8px", "verticalAlign": "middle"}}>
                        {contact.title || '--'}
                      </td>
                      <td className="overflow-ellipsis" style={{"padding": "3px 8px", "verticalAlign": "middle"}}>
                        {contact.company_name || '--'}
                      </td>
                      <td className="overflow-ellipsis" style={{"padding": "3px 8px", "verticalAlign": "middle", "background": "var(--od-c-ffffff, white)"}}>
                        {currentUser.can_manage_offer_contacts ? (
                          <Popup arrow={false}
                                offsetY={5}
                                position="bottom right"
                                contentStyle={inlineMenuContentStyle}
                                closeOnDocumentClick
                                onOpen={(e) => {
                                  e.preventDefault();
                                }}
                                trigger={open => (
                                  <a href="#" 
                                     className="text-muted"
                                     onClick={(e) => e.preventDefault()}>
                                    <i className="fas fa-ellipsis-v"></i>
                                  </a>
                                )}>
                            {close => (
                              <div>
                                <div className="row text-left">
                                  <div className="col">
                                    <ul className="list-group offer-inline-menu highlight-primary">
                                      <li className="list-group-item">
                                        <a href="#"
                                           className="text-dark"
                                           onClick={(e) => {
                                             e.preventDefault();
                                             close();
                                             editOfferContact(offerContact);
                                           }}>
                                          <i className="text-muted fas fa-edit fa-fw mx-2"></i>
                                          <span style={{"fontWeight": 'normal'}}>
                                            Edit
                                          </span>
                                        </a>
                                      </li>
                                      <li className="list-group-item delete-offer-li border-0">
                                        <a href="#"
                                           onClick={(e) => {
                                             e.preventDefault();
                                             close();
                                             deleteOfferContact(offerContact);
                                           }}
                                           className="text-danger">
                                          <i className="fas fa-trash fa-fw mx-2"></i>
                                          <span style={{"fontWeight": 'normal'}}>
                                            Remove
                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Popup>
                        ) : null}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </table>
        </div>
        {currentUser.can_manage_offer_contacts && canAddOfferContact(offerContacts, offerContactToEdit) ? (
          <button 
            onClick={addOfferContact}
            style={{
              fontSize: "14px",
              fontWeight: "600",
            }}
            className="btn btn-link text-primary p-0">
            <i className="fas fa-plus mr-2"></i>
            Add Contact
          </button>
        ) : null}
        </form>
      </div>
    </div>
  );
};

OfferManageContacts.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  offer: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  offerContacts: PropTypes.array,
  offerContactsChanged: PropTypes.func.isRequired
};

export default OfferManageContacts;
